// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';
import { ProfileRef, ProfileRefT } from '../tbs/profile-ref.js';


export class MapToLobbyAction implements flatbuffers.IUnpackableObject<MapToLobbyActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):MapToLobbyAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsMapToLobbyAction(bb:flatbuffers.ByteBuffer, obj?:MapToLobbyAction):MapToLobbyAction {
  return (obj || new MapToLobbyAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsMapToLobbyAction(bb:flatbuffers.ByteBuffer, obj?:MapToLobbyAction):MapToLobbyAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new MapToLobbyAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.MapMapToLobby;
}

profile(obj?:ProfileRef):ProfileRef|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? (obj || new ProfileRef()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

static startMapToLobbyAction(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.MapMapToLobby);
}

static addProfile(builder:flatbuffers.Builder, profileOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, profileOffset, 0);
}

static endMapToLobbyAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}


unpack(): MapToLobbyActionT {
  return new MapToLobbyActionT(
    this.type(),
    (this.profile() !== null ? this.profile()!.unpack() : null)
  );
}


unpackTo(_o: MapToLobbyActionT): void {
  _o.type = this.type();
  _o.profile = (this.profile() !== null ? this.profile()!.unpack() : null);
}
}

export class MapToLobbyActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.MapMapToLobby,
  public profile: ProfileRefT|null = null
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const profile = (this.profile !== null ? this.profile!.pack(builder) : 0);

  MapToLobbyAction.startMapToLobbyAction(builder);
  MapToLobbyAction.addType(builder, this.type);
  MapToLobbyAction.addProfile(builder, profile);

  return MapToLobbyAction.endMapToLobbyAction(builder);
}
}
